<template>
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="17" cy="17" r="17" fill="white" />
        <circle cx="17" cy="17" r="16" fill="white" stroke="#FF662D" stroke-width="2" />
        <path fill="#FF662D" fill-rule="evenodd" clip-rule="evenodd"
            d="M4.8053 28.8444L4.83307 28.8028C7.04004 25.4919 10.7338 23.5156 14.712 23.5156H19.2878C23.2661 23.5156 26.9599 25.4919 29.1669 28.8028L29.1946 28.8445C32.1687 25.783 34 21.6054 34 17C34 7.61115 26.3889 0 17 0C7.61115 0 0 7.61115 0 17C0 21.6053 1.83124 25.783 4.8053 28.8444ZM16.9999 7C12.9288 7 9.61713 10.3117 9.61713 14.3828C9.61713 18.4539 12.9288 21.7656 16.9999 21.7656C21.071 21.7656 24.3828 18.4539 24.3828 14.3828C24.3828 10.3117 21.071 7 16.9999 7Z" />
    </svg>
</template>

<script>
export default {
    name: 'ReviewsAvatar'
}
</script>

<style lang="scss" scoped></style>